import { jsx } from '@emotion/react/jsx-runtime';
var Hyphen = function Hyphen(_ref) {
  var strokeWidth = _ref.strokeWidth,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? .75 : _ref$borderRadius,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? 0 : _ref$padding,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'rgb(8, 112, 177)' : _ref$color;
  return jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    height: strokeWidth,
    style: {
      padding: "".concat(padding, "px")
    },
    className: "svg hyphen",
    children: jsx("rect", {
      x: "0",
      y: "0",
      rx: borderRadius,
      ry: borderRadius,
      height: strokeWidth,
      fill: color,
      className: "hyphen__rect"
    })
  });
};
export { Hyphen };